import React from 'react';
import TrustBadges from './TrustBadges';

const journeySteps = [
  { label: 'Discover', desc: 'Meet people who align with what you\'re looking for.' },
  { label: 'Connect', desc: 'Express interest when someone feels worth getting to know.' },
  { label: 'Talk', desc: 'Start a conversation when interest is mutual.' },
  { label: 'Meet', desc: 'Take the next step when you\'re both ready.' },
];

export default function BrandPanel() {
  return (
    <div className="hidden lg:flex lg:w-[480px] xl:w-[520px] 2xl:w-[560px] flex-col justify-between hero-gradient border-r border-border px-12 xl:px-16 py-16 relative overflow-hidden">
      {/* Decorative background elements */}
      <div
        className="absolute top-[-80px] right-[-80px] w-[320px] h-[320px] rounded-full opacity-10"
        style={{ background: 'radial-gradient(circle, var(--primary) 0%, transparent 70%)' }}
      />
      <div
        className="absolute bottom-[-60px] left-[-60px] w-[240px] h-[240px] rounded-full opacity-8"
        style={{ background: 'radial-gradient(circle, var(--gold) 0%, transparent 70%)' }}
      />
      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-16">
          <div className="w-12 h-12 rounded-2xl brand-gradient flex items-center justify-center shadow-primary-custom">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path d="M13 5C10.5 2 6 2 3.5 5C1 8 2.5 12.5 6 15L13 22L20 15C23.5 12.5 25 8 22.5 5C20 2 15.5 2 13 5Z" fill="white" fillOpacity="0.92"/>
            </svg>
          </div>
          <div>
            <span className="font-display font-semibold text-2xl text-foreground tracking-tight">SAATH</span>
            <p className="text-xs text-muted-foreground tracking-wide mt-0.5">For Bihar & Jharkhand</p>
          </div>
        </div>

        {/* Hero copy */}
        <div className="mb-12">
          <h1 className="font-display text-4xl xl:text-5xl font-semibold text-foreground leading-tight mb-4">
            Find someone worth
            <span className="block text-primary">getting to know.</span>
          </h1>
          <p className="text-base text-muted-foreground leading-relaxed max-w-xs">
            SAATH helps people in Bihar & Jharkhand discover compatible partners, start meaningful conversations, and take the next step when they're ready.
          </p>
        </div>

        {/* Journey steps */}
        <div className="space-y-4">
          {journeySteps?.map((step, i) => (
            <div key={`journey-step-${i}`} className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white border border-border flex items-center justify-center shadow-sm">
                <span className="text-xs font-bold text-primary">{i + 1}</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground">{step?.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{step?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Trust badges */}
      <div className="relative z-10">
        <TrustBadges />
      </div>
    </div>
  );
}